import {
  GETBUSINESSNATURELIST_SUCCESS,
  GETBUSINESSNATURELIST_FAILED,
  RESET_GETBUSINESSNATURELIST,
  LOADING_GETBUSINESSNATURELIST,
  NETWORK_ERROR_GETBUSINESSNATURELIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETBUSINESSNATURELIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETBUSINESSNATURELIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETBUSINESSNATURELIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETBUSINESSNATURELIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETBUSINESSNATURELIST:
      return (state = initialState);
    default:
      return state;
  }
};
